export default __webpack_public_path__ + "static/media/rybelsus-censored.130453a1.png";